/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import agAssetsDashboard from './assets-dashboard.directive';
import agAssetDashboardWidget from './asset-dashboard-widget.directive';
import agSiloDashboardWidget from './silo-dashboard-widget.directive';
import agSiloGroupDashboardWidget from './silo-group-dashboard-widget.directive';
import agWeatherStationDashboardWidget from './weather-station-dashboard-widget.directive';
import agAerationDashboardWidget from './aeration-dashboard-widget.directive';
import agSiteDashboardWidget from './site-dashboard-widget.directive';

export default angular.module('agrolog.client.asset.dashboard', [
    agAssetsDashboard,
    agAssetDashboardWidget,
    agSiloDashboardWidget,
    agSiloGroupDashboardWidget,
    agWeatherStationDashboardWidget,
    agAerationDashboardWidget,
    agSiteDashboardWidget])
    .name;
